import { combineReducers } from 'redux'

import getCart from './getCart'
import getVoucher from './getVoucher'

export default combineReducers({
  getCart,
  getVoucher,
})
